import {
  isDocRef,
  TypeGuard,
  type DocumentReference,
  type ISoftDelete,
  type Timestamp,
} from '@principle-theorem/shared';
import { type IMigrationUploadSession } from './migration-upload-session';
import { type IPracticeMigration } from './practice-migration';
import { isString } from 'lodash';

export interface IMigrationUploadCode extends ISoftDelete {
  code: string;
  sessionRef: DocumentReference<IMigrationUploadSession>;
  expiresAt: Timestamp;
  downloadToken: string;
}

export interface IGenerateUploadCodeRequest {
  migrationRef: DocumentReference<IPracticeMigration>;
  sourcePath?: string;
  conversionSourcePath?: string;
}

export const isGenerateUploadCodeRequest =
  TypeGuard.interface<IGenerateUploadCodeRequest>({
    migrationRef: isDocRef,
    sourcePath: TypeGuard.nilOr(isString),
    conversionSourcePath: TypeGuard.nilOr(isString),
  });

export interface IRefreshUploadCodeRequest {
  sessionId: string;
}

export interface IRefreshUploadCodeResponse {
  code: string;
  expiresAt: Timestamp;
  downloadUrl: string;
}

export interface IGenerateUploadCodeResponse {
  code: string;
  sessionId: string;
  expiresAt: Timestamp;
  downloadUrl: string;
}
